module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Regular.ade2109.woff";